import { ELinksActionTypes } from '../../actions/links';
import { TReduxActions } from '../../types/redux';
import { ILegalDocumentLink } from '../../types/link';

export function linksReducer(state: ILegalDocumentLink[] = [], action: TReduxActions) {
  if (action.type === ELinksActionTypes.SetLinks) {
    return {
      ...state,
      ...action.payload,
    };
  }

  return state;
}
